import Loader from "components/loader/Loader";
import React, { useState, useEffect } from "react";

type Props = {
  children: React.ReactNode;
  waitBeforeShow?: number;
};

const Page5ProfileDelayed = ({ children, waitBeforeShow = 200 }: any) => {
  const [isShown, setIsShown] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsShown(true);
    }, waitBeforeShow);
    return () => clearTimeout(timer);
  }, [waitBeforeShow]);

  return isShown ? children : <Loader />;
};

export default Page5ProfileDelayed;
